import * as R from "ramda";

export const DEFAULT_ON_CLICK = R.always(undefined);
